/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import ApiClientBase from "./ApiClientBase";
import ApiClientOptions from "./ApiClientOptions"
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import * as moment from 'moment';

export class ApiClient extends ApiClientBase {
    //private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientOptions, baseUrl?: string, instance?: AxiosInstance) {
        super(configuration);
        //this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44354";
    }

    getNewsData(  cancelToken?: CancelToken | undefined): Promise<News> {
        let url_ = this.baseUrl + "/samplehub/NewsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsData(_response);
        });
    }

    protected processGetNewsData(response: AxiosResponse): Promise<News> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<News>(<any>null);
    }

    teamMemberDetails(  cancelToken?: CancelToken | undefined): Promise<TeamMemberDetails[]> {
        let url_ = this.baseUrl + "/samplehub/TeamMemberDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamMemberDetails(_response);
        });
    }

    protected processTeamMemberDetails(response: AxiosResponse): Promise<TeamMemberDetails[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamMemberDetails[]>(<any>null);
    }

    getUserAccessToken(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/samplehub/GetUserAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAccessToken(_response);
        });
    }

    protected processGetUserAccessToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    getAnnouncementAdaptiveCardDetails(  cancelToken?: CancelToken | undefined): Promise<CompanyCommunicatorTableData> {
        let url_ = this.baseUrl + "/samplehub/AnnouncementAdaptiveCardDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnnouncementAdaptiveCardDetails(_response);
        });
    }

    protected processGetAnnouncementAdaptiveCardDetails(response: AxiosResponse): Promise<CompanyCommunicatorTableData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyCommunicatorTableData>(<any>null);
    }

    getTeamsConfig(  cancelToken?: CancelToken | undefined): Promise<TeamsConfiguration> {
        let url_ = this.baseUrl + "/samplehub/TeamsConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeamsConfig(_response);
        });
    }

    protected processGetTeamsConfig(response: AxiosResponse): Promise<TeamsConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamsConfiguration>(<any>null);
    }

    getSharepointConfig(  cancelToken?: CancelToken | undefined): Promise<SharePointConfiguration> {
        let url_ = this.baseUrl + "/samplehub/SharepointConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharepointConfig(_response);
        });
    }

    protected processGetSharepointConfig(response: AxiosResponse): Promise<SharePointConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SharePointConfiguration>(<any>null);
    }

    getSharepointNewsThumbnails(requests: ThumbnailRequest[] , cancelToken?: CancelToken | undefined): Promise<ThumbnailResponse[]> {
        let url_ = this.baseUrl + "/samplehub/NewsThumbnails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requests);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharepointNewsThumbnails(_response);
        });
    }

    protected processGetSharepointNewsThumbnails(response: AxiosResponse): Promise<ThumbnailResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThumbnailResponse[]>(<any>null);
    }

    getSharepointNewsCategories(  cancelToken?: CancelToken | undefined): Promise<NewsCategoriesResponse> {
        let url_ = this.baseUrl + "/samplehub/NewsCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharepointNewsCategories(_response);
        });
    }

    protected processGetSharepointNewsCategories(response: AxiosResponse): Promise<NewsCategoriesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsCategoriesResponse>(<any>null);
    }

    getPersonalNews(  cancelToken?: CancelToken | undefined): Promise<ApiNewsResponse[]> {
        let url_ = this.baseUrl + "/samplehub/PersonalNews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPersonalNews(_response);
        });
    }

    protected processGetPersonalNews(response: AxiosResponse): Promise<ApiNewsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiNewsResponse[]>(<any>null);
    }

    getFilteredNews(valoTags: string[] | null | undefined, locations: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<ApiNewsResponse[]> {
        let url_ = this.baseUrl + "/samplehub/FilteredNews?";
        if (valoTags !== undefined && valoTags !== null)
            valoTags && valoTags.forEach(item => { url_ += "valoTags=" + encodeURIComponent("" + item) + "&"; });
        if (locations !== undefined && locations !== null)
            locations && locations.forEach(item => { url_ += "locations=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredNews(_response);
        });
    }

    protected processGetFilteredNews(response: AxiosResponse): Promise<ApiNewsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiNewsResponse[]>(<any>null);
    }
}

export interface News {
    value: Value[] | undefined;
}

export interface Value {
    title: string | undefined;
    description: string | undefined;
    oDataOriginalSourceUrl: string | undefined;
}

export interface TeamMemberDetails {
    givenName: string | undefined;
    userPrincipalName: string | undefined;
    jobTitle: string | undefined;
    profilePhotoUrl: string | undefined;
}

export interface CompanyCommunicatorTableData {
    value: Record[] | undefined;
}

export interface Record {
    partitionKey: string | undefined;
    rowKey: string | undefined;
    content: string | undefined;
    teamsInString: string | undefined;
}

export interface TeamsConfiguration {
    shiftsAppId: string | undefined;
    tasksAppId: string | undefined;
    newsAppId: string | undefined;
    payStubsAppId: string | undefined;
    benefitsAppId: string | undefined;
    rewardsAppId: string | undefined;
    kudosAppId: string | undefined;
    deepLinkBaseUrl: string | undefined;
    surveyAppId: string | undefined;
    supportAppId: string | undefined;
    trainingAppId: string | undefined;
    portalAppId: string | undefined;
    insightsAppId: string | undefined;
    handBookUrl: string | undefined;
    reportAppId: string | undefined;
    channelChatUrl: string | undefined;
    trainingVideoUrl: string | undefined;
    teamId: string | undefined;
}

export interface SharePointConfiguration {
    siteGuuid: string | undefined;
    listGuuid: string | undefined;
    clientId: string | undefined;
    valoCategoryTaxonomyGroupId: string | undefined;
    valoCategoryTaxonomySetIds: string[] | undefined;
}

export interface ThumbnailResponse {
    id: string | undefined;
    b64Content: string | undefined;
    httpCode: number;
}

export interface ThumbnailRequest {
    id: string | undefined;
    url: string | undefined;
}

export interface NewsCategoriesResponse {
    accountName: string | undefined;
    csMyNews: string[] | undefined;
    csMyLocations: string[] | undefined;
    csMyHR: string[] | undefined;
}

export interface NewsDTO {
    path: string | undefined;
    title: string | undefined;
    author: string | undefined;
    pictureThumbnailURL: string | undefined;
    description: string | undefined;
    listID: string | undefined;
    listItemID: string | undefined;
    valoOfficeLocation: string | undefined;
    firstPublishedDate: Date;
    spWebUrl: string | undefined;
    siteId: string | undefined;
    originalPath: string | undefined;
    uniqueId: string | undefined;
}

export interface ApiNewsResponse extends NewsDTO {
    valoTags: string[] | undefined;
    highlight: boolean;
    thumbnail: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

